module.exports = __webpack_public_path__ + "img/IRES_Portal_sRGB_neg_white.28ae1bb1.png";